<div class="dialog-header">
  <div class="header-title">
		<span style="font-size: 120%;">
			List of service orders
		</span>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>


<div class="list-block" *ngIf="!loadingSpinner">
  <div class="service-order-block" *ngFor="let task of shortTasks" (click)="addToOrder(task)" matRipple>
      SO-{{task.number}}
  </div>
  <div class="no-order-title" *ngIf="!shortTasks.length">
    No Opened Service Orders
  </div>
</div>

<div class="list-block" *ngIf="loadingSpinner">
  <lib-progress-spinner></lib-progress-spinner>
</div>
